<template>
  <div class="cart-header">
    <button class="btn btn-sm btn-icon" @click="close">
      <span class="ti-arrow-left"></span>
      {{'back' | setText('Назад')}}
    </button>
  </div>
</template>
<script>
export default {
  name: "header",
  props: ["card"],
  methods: {
    close() {
      let query = Object.assign({}, this.$route.query);
      if (query[this.card]) {
        // let dep = Object.keys(query).find(e=>{ return /dep_/.test(e) })
        // if(dep)
        //   delete query[dep]
        delete query[this.card];
      } else {
        return false;
      }
      this.$router.replace({ query });
    },
  },
  components: {},
};
</script>
<style>
</style>
